// const formatPercentage = (value, decimals = 2) => {
//   return `${(value * 100).toFixed(decimals)}%`;
// };

const columns = [
  {
    name: 'Month',
    selector: (row) => row?.month,
  },
  {
    name: 'Users',
    selector: (row) => row?.users,
  },
  {
    name: 'Devices',
    selector: (row) => row?.devices,
  },
  {
    name: 'Usage Total',
    selector: (row) => row?.usagetotal,
  }, 
  {
    name: 'Phone Devices',
    selector: (row) => row?.phonedevices,
  },
  {
    name: 'Incdt/Month',
    selector: (row) => row?.incidents,
  },
  {
    name: 'Percent',
    selector: (row) => row?.percent,
  },
  {
    name: 'System Incidents',
    selector: (row) => row?.system_incidents,
  },
  {
    name: 'Send to Local',
    selector: (row) => row?.sent_to_local,
  }
];
const mobileColumns = [
  {
    name: 'User',
    selector: (row) => row?.users,
  },
  {
    name: 'Devices',
    selector: (row) => row?.devices,
  },
];

export { columns, mobileColumns };
